/* DLUX — FAQ + Ask the shop (A2). Vanilla JS, no framework.
 * Hydrates [data-faq-ask] blocks: accordion + ask state machine.
 */
(function () {
  if (window.__dluxFaqAskInit) return;
  window.__dluxFaqAskInit = true;

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var MAX_HISTORY = 12;

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  // Tiny markdown renderer for model output. Input is plain text; we escape
  // first, then convert the safe subset (bold/italic/links/lists/paragraphs).
  // We never accept raw HTML from the model — only literal * _ - 1. [ tokens
  // become tags.
  function renderMarkdown(raw) {
    var s = escapeHtml(raw || '').replace(/\r\n/g, '\n');

    // Inline links [text](url). Accepts http(s):// absolute URLs OR site-
    // relative /paths (e.g. "/products/handle"). Anything else is rejected
    // and the raw markdown remains as plain text — we never accept javascript:
    // or other schemes from the model.
    s = s.replace(/\[([^\]\n]+)\]\s*\(([^\s)]+)\)/g,
      function (m, text, url) {
        if (/^https?:\/\//i.test(url)) {
          return '<a href="' + url + '" target="_blank" rel="noopener noreferrer">' + text + '</a>';
        }
        if (/^\/[A-Za-z0-9/_\-?&=#%.]*$/.test(url)) {
          return '<a href="' + url + '" target="_blank" rel="noopener">' + text + '</a>';
        }
        return m; // unsafe scheme — leave literal
      });

    // Bold **text** (must come before single-star italic)
    s = s.replace(/\*\*([^\n*][^\n]*?)\*\*/g, '<strong>$1</strong>');

    // Italic *text* (avoid touching ** that was already consumed)
    s = s.replace(/(^|[^*\w])\*([^\n*][^\n]*?)\*(?!\*)/g, '$1<em>$2</em>');
    // Italic _text_ when bounded by non-word chars
    s = s.replace(/(^|[^_\w])_([^\n_][^\n]*?)_(?!\w)/g, '$1<em>$2</em>');

    // Bullet lists: blocks of consecutive "- " or "* " lines
    s = s.replace(/(?:^|\n)((?:[-*] +[^\n]+(?:\n|$))+)/g, function (_m, block) {
      var items = block.trim().split(/\n/).map(function (line) {
        return '<li>' + line.replace(/^[-*]\s+/, '') + '</li>';
      }).join('');
      return '\n<ul>' + items + '</ul>';
    });

    // Numbered lists: blocks of "1. " "2. " lines
    s = s.replace(/(?:^|\n)((?:\d+\. +[^\n]+(?:\n|$))+)/g, function (_m, block) {
      var items = block.trim().split(/\n/).map(function (line) {
        return '<li>' + line.replace(/^\d+\.\s+/, '') + '</li>';
      }).join('');
      return '\n<ol>' + items + '</ol>';
    });

    // Paragraphs: split on blank lines. Wrap plain text in <p>, leave list
    // blocks as-is. Single newlines inside a paragraph become <br>.
    var parts = s.split(/\n{2,}/);
    return parts.map(function (p) {
      var t = p.trim();
      if (!t) return '';
      if (/^<(ul|ol|p|h\d)/.test(t)) return t;
      return '<p>' + t.replace(/\n/g, '<br>') + '</p>';
    }).join('');
  }

  /* ---------------- Accordion ---------------- */
  function initAccordion(root) {
    var btns = root.querySelectorAll('[data-faq-ask-toggle]');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.faq-ask__item');
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (open) {
          if (panel) panel.setAttribute('hidden', '');
          item && item.classList.remove('is-open');
        } else {
          if (panel) panel.removeAttribute('hidden');
          item && item.classList.add('is-open');
        }
      });
    });
  }

  /* ---------------- Ask state machine ---------------- */
  function AskBlock(el) {
    this.el = el;
    this.root = el.querySelector('[data-faq-ask-root]');
    this.productId = el.dataset.productId || '';
    this.endpoint = el.dataset.endpoint || '';
    this.oosEmail = el.dataset.oosEmail || 'contact@dlux-essentials.com';
    this.storageKey = 'faq-ask:' + this.productId;
    this.busy = false;
    this.history = [];
    this.turns = []; // [{ q, a, productRef?, suggestions? }]
    this.state = 'resting';

    this.chipTexts = [];
    var chipNodes = el.querySelectorAll('[data-faq-ask-chip]');
    for (var i = 0; i < chipNodes.length; i++) this.chipTexts.push(chipNodes[i].textContent.trim());
    this.placeholder = (el.querySelector('[data-faq-ask-input]') || {}).placeholder || 'e.g. Is this suitable for sensitive skin?';

    this.hydrate();
    this.render();
    this.bindDelegation();
  }

  AskBlock.prototype.hydrate = function () {
    try {
      var raw = localStorage.getItem(this.storageKey);
      if (!raw) return;
      var data = JSON.parse(raw);
      if (data && data.productId === this.productId && Array.isArray(data.turns)) {
        this.turns = data.turns.slice(-MAX_HISTORY);
        this.history = data.history || [];
        this.state = this.turns.length ? 'answer' : 'resting';
      } else {
        localStorage.removeItem(this.storageKey);
      }
    } catch (e) { /* ignore */ }
  };

  AskBlock.prototype.persist = function () {
    try {
      localStorage.setItem(this.storageKey, JSON.stringify({
        productId: this.productId,
        turns: this.turns.slice(-MAX_HISTORY),
        history: this.history.slice(-MAX_HISTORY * 2),
        state: this.state
      }));
    } catch (e) { /* ignore */ }
  };

  AskBlock.prototype.reset = function () {
    this.turns = [];
    this.history = [];
    this.state = 'resting';
    try { localStorage.removeItem(this.storageKey); } catch (e) {}
    this.render();
  };

  AskBlock.prototype.bindDelegation = function () {
    var self = this;
    this.root.addEventListener('click', function (evt) {
      var t = evt.target.closest('[data-faq-ask-chip]');
      if (t && !self.busy) {
        evt.preventDefault();
        self.submit(t.textContent.trim());
        return;
      }
      var reset = evt.target.closest('[data-faq-ask-reset]');
      if (reset) { evt.preventDefault(); self.reset(); return; }
      var retry = evt.target.closest('[data-faq-ask-retry]');
      if (retry && !self.busy && self.lastQuestion) {
        evt.preventDefault();
        self.submit(self.lastQuestion);
        return;
      }
      var helpful = evt.target.closest('[data-faq-ask-helpful]');
      if (helpful) {
        evt.preventDefault();
        if (helpful.hasAttribute('disabled')) return;
        var row = helpful.closest('.faq-ask__helpful');
        var vote = helpful.getAttribute('data-faq-ask-helpful');
        self.recordVote(row, vote);
      }
    });

    this.root.addEventListener('submit', function (evt) {
      var f = evt.target.closest('[data-faq-ask-form]');
      if (!f) return;
      evt.preventDefault();
      var input = f.querySelector('[data-faq-ask-input]');
      var val = input && input.value ? input.value.trim() : '';
      if (!val) return;
      self.submit(val);
    });
  };

  AskBlock.prototype.voteKey = function (question) {
    return 'faq-ask:vote:' + this.productId + '::' + (question || '').toLowerCase().slice(0, 200);
  };

  AskBlock.prototype.loadVote = function (question) {
    try {
      return localStorage.getItem(this.voteKey(question));
    } catch (e) { return null; }
  };

  AskBlock.prototype.saveVote = function (question, vote) {
    try { localStorage.setItem(this.voteKey(question), vote); } catch (e) { /* ignore */ }
  };

  AskBlock.prototype.recordVote = function (row, vote) {
    if (vote !== 'up' && vote !== 'down') return;
    var last = this.turns && this.turns.length ? this.turns[this.turns.length - 1] : null;
    if (!last) return;
    if (this.loadVote(last.q)) return; // already voted
    this.saveVote(last.q, vote);
    if (row) this.renderVoted(row, vote);
    this.sendFeedback(vote);
  };

  AskBlock.prototype.renderVoted = function (row, vote) {
    if (!row) return;
    var thanks = vote === 'down'
      ? 'Thanks. We’ll review this answer.'
      : 'Thanks for the feedback.';
    // Replace the row contents in place so the "Start over" button is kept.
    var reset = row.querySelector('[data-faq-ask-reset]');
    row.innerHTML = '';
    var msg = document.createElement('span');
    msg.className = 'faq-ask__helpful-thanks';
    msg.textContent = thanks;
    msg.setAttribute('aria-live', 'polite');
    row.appendChild(msg);
    if (reset) {
      reset.style.marginLeft = 'auto';
      row.appendChild(reset);
    }
  };

  AskBlock.prototype.feedbackEndpoint = function () {
    if (!this.endpoint) return '';
    // Append /feedback to whatever chat URL is configured. Tolerates a
    // trailing slash on the chat endpoint setting.
    return this.endpoint.replace(/\/+$/, '') + '/feedback';
  };

  AskBlock.prototype.sendFeedback = function (vote) {
    if (vote !== 'up' && vote !== 'down') return;
    var url = this.feedbackEndpoint();
    if (!url) return;
    var last = this.turns && this.turns.length ? this.turns[this.turns.length - 1] : null;
    if (!last) return;
    var handle = this.el && this.el.dataset ? this.el.dataset.productHandle || null : null;
    // Fire-and-forget; never block UI on it.
    try {
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        // keepalive lets the request survive navigation away.
        keepalive: true,
        body: JSON.stringify({
          product_id: this.productId,
          product_handle: handle,
          question: last.q,
          answer: last.a,
          vote: vote,
          source: last.source || 'llm'
        })
      }).catch(function () { /* swallow */ });
    } catch (e) { /* ignore */ }
  };

  AskBlock.prototype.setBusy = function (busy) {
    this.busy = busy;
    var btns = this.root.querySelectorAll('[data-faq-ask-submit], [data-faq-ask-chip]');
    btns.forEach(function (b) {
      if (busy) b.setAttribute('disabled', ''); else b.removeAttribute('disabled');
    });
  };

  AskBlock.prototype.submit = function (question) {
    if (!this.endpoint || !this.productId) {
      this.state = 'oos';
      this.oosReason = 'config';
      this.lastQuestion = question;
      this.render();
      return;
    }
    var self = this;
    self.lastQuestion = question;
    self.state = 'loading';
    self.render();
    self.setBusy(true);

    fetch(self.endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        // Ask for SSE; worker falls back to JSON if it can't stream.
        'Accept': 'text/event-stream'
      },
      body: JSON.stringify({
        product_id: self.productId,
        question: question,
        history: self.history.slice(-MAX_HISTORY * 2)
      })
    })
      .then(function (res) {
        if (res.status === 429) return self._finalizeError('rate_limited');
        if (!res.ok) return self._finalizeError('http_' + res.status);
        var ct = (res.headers.get('Content-Type') || '').toLowerCase();
        if (ct.indexOf('text/event-stream') >= 0 && res.body && res.body.getReader) {
          return self._consumeStream(res, question);
        }
        return res.json().then(function (data) { self._finalizeJson(data, question); });
      })
      .catch(function () { self._finalizeError('network'); });
  };

  AskBlock.prototype._finalizeError = function (reason) {
    this.state = 'error';
    this.errorReason = reason;
    this.setBusy(false);
    this.render();
  };

  AskBlock.prototype._finalizeJson = function (data, question) {
    data = data || {};
    var serverError =
      !data.ok && data.error &&
      data.error !== 'out_of_scope' && data.error !== 'oos';
    if (serverError) return this._finalizeError(data.error);
    var oos = data.outOfScope === true ||
      (!data.ok && (data.error === 'out_of_scope' || data.error === 'oos')) ||
      !data.answer;
    if (oos) {
      this.state = 'oos';
      this.oosReason = data.error || 'oos';
      this.setBusy(false);
      this.render();
      return;
    }
    this._commitAnswer(question, data.answer, data);
  };

  AskBlock.prototype._commitAnswer = function (question, answer, data) {
    data = data || {};
    this.turns.push({
      q: question,
      a: answer,
      source: data.source || 'llm',
      productRef: data.productRef || null,
      suggestions: Array.isArray(data.suggestions) ? data.suggestions.slice(0, 3) : []
    });
    this.history.push({ role: 'user', content: question });
    this.history.push({ role: 'assistant', content: answer });
    this.state = 'answer';
    this.persist();
    this.setBusy(false);
    this.render();
    this.focusInput();
  };

  AskBlock.prototype._consumeStream = function (res, question) {
    var self = this;
    var reader = res.body.getReader();
    var decoder = new TextDecoder();
    var buffer = '';
    var streamedText = '';
    var doneEvent = null;
    var errorReason = null;

    // Switch UI to streaming view; renderStreaming reads self._streamingText.
    self.state = 'streaming';
    self._streamingText = '';
    self.render();

    function flushFrame(frame) {
      var eventName = 'message';
      var dataLine = '';
      var lines = frame.split('\n');
      for (var i = 0; i < lines.length; i++) {
        var line = lines[i];
        if (line.indexOf('event:') === 0) eventName = line.slice(6).trim();
        else if (line.indexOf('data:') === 0) dataLine += line.slice(5).trim();
      }
      if (!dataLine) return;
      var payload;
      try { payload = JSON.parse(dataLine); } catch (e) { return; }
      if (eventName === 'delta' && payload && typeof payload.delta === 'string') {
        streamedText += payload.delta;
        self._streamingText = streamedText;
        var target = self.root.querySelector('[data-faq-ask-streaming]');
        if (target) target.innerHTML = renderMarkdown(streamedText);
      } else if (eventName === 'done') {
        doneEvent = payload || {};
      } else if (eventName === 'error') {
        errorReason = (payload && payload.error) || 'stream_error';
      }
    }

    function pump() {
      return reader.read().then(function (chunk) {
        if (chunk.done) {
          if (errorReason) return self._finalizeError(errorReason);
          if (doneEvent && doneEvent.outOfScope) {
            self.state = 'oos';
            self.oosReason = 'oos';
            self.setBusy(false);
            self.render();
            return;
          }
          var finalAnswer = (doneEvent && doneEvent.answer) || streamedText;
          if (!finalAnswer) return self._finalizeError('empty_stream');
          self._commitAnswer(question, finalAnswer, doneEvent || {});
          return;
        }
        buffer += decoder.decode(chunk.value, { stream: true });
        var sep;
        while ((sep = buffer.indexOf('\n\n')) >= 0) {
          var frame = buffer.slice(0, sep);
          buffer = buffer.slice(sep + 2);
          if (frame.trim()) flushFrame(frame);
        }
        return pump();
      });
    }

    return pump().catch(function () { self._finalizeError('network'); });
  };

  AskBlock.prototype.focusInput = function () {
    var input = this.root.querySelector('[data-faq-ask-input]');
    if (input) input.focus();
  };

  AskBlock.prototype.render = function () {
    var html = '';
    if (this.state === 'resting') html = this.renderResting();
    else if (this.state === 'loading') html = this.renderLoading();
    else if (this.state === 'streaming') html = this.renderStreaming();
    else if (this.state === 'oos') html = this.renderOOS();
    else if (this.state === 'error') html = this.renderError();
    else html = this.renderAnswer();
    this.root.innerHTML = html;
    this.rehydrateVote();
  };

  // After every render, restore the "Thanks" state on the helpful row if the
  // shopper already voted on the current last turn. Survives reload because
  // votes are persisted in localStorage.
  AskBlock.prototype.rehydrateVote = function () {
    var row = this.root.querySelector('.faq-ask__helpful');
    if (!row) return;
    var last = this.turns && this.turns.length ? this.turns[this.turns.length - 1] : null;
    if (!last) return;
    var existing = this.loadVote(last.q);
    if (existing === 'up' || existing === 'down') {
      this.renderVoted(row, existing);
    }
  };

  AskBlock.prototype.renderResting = function () {
    var chips = this.chipTexts.map(function (t) {
      return '<button type="button" class="faq-ask__chip" data-faq-ask-chip>' + escapeHtml(t) + '</button>';
    }).join('');
    return ''
      + '<div class="faq-ask__state faq-ask__state--resting">'
      +   (chips ? '<div class="faq-ask__chips">' + chips + '</div>' : '')
      +   this.renderForm('e.g. Is this suitable for sensitive skin?')
      + '</div>';
  };

  AskBlock.prototype.renderForm = function (placeholder) {
    return ''
      + '<form class="faq-ask__form" data-faq-ask-form novalidate>'
      +   '<label class="visually-hidden" for="' + this.inputId() + '">Ask a question about this product</label>'
      +   '<input id="' + this.inputId() + '" class="faq-ask__input" type="text" name="question" maxlength="500" autocomplete="off" placeholder="' + escapeHtml(placeholder || this.placeholder) + '" data-faq-ask-input required>'
      +   '<button type="submit" class="faq-ask__submit" data-faq-ask-submit>Ask</button>'
      + '</form>';
  };

  AskBlock.prototype.inputId = function () {
    return 'faq-ask-input-' + (this.productId.replace(/[^a-z0-9]/gi, '') || 'x');
  };

  AskBlock.prototype.renderLoading = function () {
    var q = escapeHtml(this.lastQuestion || '');
    return ''
      + '<div class="faq-ask__state faq-ask__state--loading">'
      +   '<p class="faq-ask__user">' + q + '</p>'
      +   '<div class="faq-ask__loading" aria-label="Checking the product details">'
      +     '<span class="faq-ask__dots"><span class="faq-ask__dot"></span><span class="faq-ask__dot"></span><span class="faq-ask__dot"></span></span>'
      +     '<span class="faq-ask__loading-text">Checking the product details…</span>'
      +   '</div>'
      + '</div>';
  };

  AskBlock.prototype.renderError = function () {
    var q = escapeHtml(this.lastQuestion || '');
    var reasonHints = {
      rate_limited: 'You’ve sent a lot of questions in a short window. Try again in an hour.',
      network: 'Couldn’t reach the shop. Check your connection and try again.',
      generation_failed: 'Something went wrong on our end. Please try again.',
      product_not_found: 'I couldn’t look up this product. Refresh the page and try again.'
    };
    var hint = reasonHints[this.errorReason] || 'Something went wrong. Please try again.';
    return ''
      + '<div class="faq-ask__state faq-ask__state--error">'
      +   (q ? '<p class="faq-ask__user">' + q + '</p>' : '')
      +   '<p class="faq-ask__error-body">' + escapeHtml(hint) + '</p>'
      +   '<div class="faq-ask__error-actions">'
      +     '<button type="button" class="faq-ask__submit" data-faq-ask-retry>Try again</button>'
      +     '<button type="button" class="faq-ask__reset" data-faq-ask-reset>Start over</button>'
      +   '</div>'
      + '</div>';
  };

  AskBlock.prototype.renderStreaming = function () {
    var q = escapeHtml(this.lastQuestion || '');
    var initial = renderMarkdown(this._streamingText || '');
    return ''
      + '<div class="faq-ask__state faq-ask__state--streaming">'
      +   (q ? '<p class="faq-ask__user">' + q + '</p>' : '')
      +   '<hr class="faq-ask__dashed">'
      +   '<div class="faq-ask__answer-body faq-ask__answer-body--streaming" data-faq-ask-streaming>' + initial + '</div>'
      + '</div>';
  };

  AskBlock.prototype.renderOOS = function () {
    var q = escapeHtml(this.lastQuestion || '');
    return ''
      + '<div class="faq-ask__state faq-ask__state--oos">'
      +   (q ? '<p class="faq-ask__user">' + q + '</p>' : '')
      +   '<h4 class="faq-ask__oos-h">We can’t answer that one here.</h4>'
      +   '<p class="faq-ask__oos-body">This box only covers this product. For routines, allergies or anything medical, email us:</p>'
      +   '<a class="faq-ask__oos-link" href="mailto:' + escapeHtml(this.oosEmail) + '">' + escapeHtml(this.oosEmail) + '</a>'
      +   '<div style="margin-top:18px">' + this.renderForm('Ask another…') + '</div>'
      +   '<button type="button" class="faq-ask__reset" data-faq-ask-reset>Start over</button>'
      + '</div>';
  };

  AskBlock.prototype.renderAnswer = function () {
    var self = this;
    var turnsHtml = this.turns.map(function (t, idx) {
      var card = t.productRef ? self.renderCard(t.productRef) : '';
      var follow = (t.suggestions && t.suggestions.length) ? self.renderFollowChips(t.suggestions) : '';
      return ''
        + '<div class="faq-ask__turn">'
        +   (idx === 0 ? '' : '')
        +   '<p class="faq-ask__user">' + escapeHtml(t.q) + '</p>'
        +   '<hr class="faq-ask__dashed">'
        +   '<div class="faq-ask__answer-body">' + renderMarkdown(t.a) + '</div>'
        +   card
        +   follow
        + '</div>';
    }).join('');

    return ''
      + '<div class="faq-ask__state faq-ask__state--answer">'
      +   turnsHtml
      +   this.renderForm('Ask another…')
      +   '<div class="faq-ask__helpful" role="group" aria-label="Was this helpful?">'
      +     '<span>Was this helpful?</span>'
      +     '<button type="button" class="faq-ask__helpful-btn" data-faq-ask-helpful="up" aria-label="Yes">'
      +       '<svg width="14" height="14" viewBox="0 0 24 24"><use href="#faq-ask-icon-thumb-up"/></svg>'
      +     '</button>'
      +     '<button type="button" class="faq-ask__helpful-btn" data-faq-ask-helpful="down" aria-label="No">'
      +       '<svg width="14" height="14" viewBox="0 0 24 24"><use href="#faq-ask-icon-thumb-down"/></svg>'
      +     '</button>'
      +     '<button type="button" class="faq-ask__reset" data-faq-ask-reset style="margin-left:auto">Start over</button>'
      +   '</div>'
      + '</div>';
  };

  AskBlock.prototype.renderCard = function (ref) {
    var href = ref.handle ? '/products/' + encodeURIComponent(ref.handle) : '#';
    return ''
      + '<p class="faq-ask__card-label">Mentioned in this answer</p>'
      + '<a class="faq-ask__card" href="' + escapeHtml(href) + '" target="_blank" rel="noopener">'
      +   (ref.image ? '<img class="faq-ask__card-img" src="' + escapeHtml(ref.image) + '" alt="">' : '<span class="faq-ask__card-img" aria-hidden="true"></span>')
      +   '<span class="faq-ask__card-body">'
      +     (ref.brand ? '<span class="faq-ask__card-brand">' + escapeHtml(ref.brand) + '</span>' : '')
      +     '<span class="faq-ask__card-title">' + escapeHtml(ref.title || '') + '</span>'
      +     '<span class="faq-ask__card-baseline">'
      +       '<span>' + escapeHtml(ref.size || '') + '</span>'
      +       '<span class="faq-ask__card-price">' + escapeHtml(ref.price || '') + '</span>'
      +     '</span>'
      +   '</span>'
      + '</a>';
  };

  AskBlock.prototype.renderFollowChips = function (items) {
    var chips = items.map(function (s) {
      return ''
        + '<button type="button" class="faq-ask__chip faq-ask__chip--follow" data-faq-ask-chip>'
        +   '<svg class="faq-ask__chip-corner" width="10" height="10" viewBox="0 0 12 12"><use href="#faq-ask-icon-corner"/></svg>'
        +   '<span>' + escapeHtml(s) + '</span>'
        + '</button>';
    }).join('');
    return ''
      + '<p class="faq-ask__follow-eyebrow">You might also ask</p>'
      + '<div class="faq-ask__chips">' + chips + '</div>';
  };

  /* ---------------- Boot ---------------- */
  function boot() {
    document.querySelectorAll('.faq-ask').forEach(function (root) {
      initAccordion(root);
      var ask = root.querySelector('[data-faq-ask]');
      if (ask) new AskBlock(ask);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
